import { registerSW } from "virtual:pwa-register";

export const registerServiceWorker = (): void => {
  if (typeof window === "undefined") return;
  registerSW({
    immediate: true,
    onRegisteredSW: (_swUrl, _registration) => {
      // no-op
    },
    onOfflineReady: () => {
      // could surface a toast; the app is silent for now.
    },
    onNeedRefresh: () => {
      // autoUpdate handles this — leaving the hook for future UI.
    },
  });
};
